export const updateOrganizationCancelationTypes = [
  'UPDATE_ORGANIZATION_CANCELATION',
  'UPDATE_ORGANIZATION_CANCELATION_SUCCESS',
  'UPDATE_ORGANIZATION_CANCELATION_FAIL',
];

export const updateReviewMandatoryTypes = [
  'UPDATE_REVIEW_MANDATORY',
  'UPDATE_REVIEW_MANDATORY_SUCCESS',
  'UPDATE_REVIEW_MANDATORY_FAIL',
];

export const updateSurveySkippableTypes = [
  'UPDATE_SURVEY_SKIPPABLE',
  'UPDATE_SURVEY_SKIPPABLE_SUCCESS',
  'UPDATE_SURVEY_SKIPPABLE_FAIL',
];

export const updateServiceFeeTypes = [
  'UPDATE_SERVICE_FEE',
  'UPDATE_SERVICE_FEE_SUCCESS',
  'UPDATE_SERVICE_FEE_FAIL',
];

export const updateCommissionStructureTypes = [
  'UPDATE_COMMISSION_STRUCTURE',
  'UPDATE_COMMISSION_STRUCTURE_SUCCESS',
  'UPDATE_COMMISSION_STRUCTURE_FAIL',
];

export const updateSupportTypes = [
  'UPDATE_SUPPORT',
  'UPDATE_SUPPORT_SUCCESS',
  'UPDATE_SUPPORT_FAIL',
];

export const updateOrganizationSplitChargeTypes = [
  'UPDATE_ORGANIZATION_SPLIT_CHARGE',
  'UPDATE_ORGANIZATION_SPLIT_CHARGE_SUCCESS',
  'UPDATE_ORGANIZATION_SPLIT_CHARGE_FAIL',
];

export const organizationStripeLoginLinkTypes = [
  'ORGANIZATION_STRIPE_LOGIN_LINK',
  'ORGANIZATION_STRIPE_LOGIN_LINK_SUCCESS',
  'ORGANIZATION_STRIPE_LOGIN_LINK_FAIL',
];



// WEBPACK FOOTER //
// ./src/modules/organization/action_types.js